var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "PointList",
      "extra-items": _vm.isReadOnly ? ['查看點數'] : _vm.isEditing ? ['編輯點數'] : ['新增點數']
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? "查看點數" : _vm.isEditing ? "編輯點數" : "新增點數") + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.merchantId,
      callback: function callback($$v) {
        _vm.merchantId = $$v;
      },
      expression: "merchantId"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "會員 id"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.customerInfo,
      callback: function callback($$v) {
        _vm.customerInfo = $$v;
      },
      expression: "customerInfo"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.point.customer_id.$error
    }
  }, [_vm._v("此欄位為必填")]), !_vm.isReadOnly ? _c('PointAddCustomer', {
    attrs: {
      "customerId": _vm.point.customer_id,
      "merchantId": _vm.merchantId
    },
    on: {
      "added": _vm.selectedCustomer
    }
  }) : _vm._e()], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "訂單 id"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.point.order_id,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "order_id", $$v);
      },
      expression: "point.order_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "分店 id"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.point.branch_id,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "branch_id", $$v);
      },
      expression: "point.branch_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "點數"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.point.point,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "point", $$v);
      },
      expression: "point.point"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.point.point.$error
    }
  }, [_vm._v("此欄位為必填且正整數")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "入點說明"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.point.description,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "description", $$v);
      },
      expression: "point.description"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "開始時間"
    }
  }, [_c('AppDateTimePicker', {
    model: {
      value: _vm.point.start_at,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "start_at", $$v);
      },
      expression: "point.start_at"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "過期時間"
    }
  }, [_c('AppDateTimePicker', {
    model: {
      value: _vm.point.expired_at,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "expired_at", $$v);
      },
      expression: "point.expired_at"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動 id"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.point.event_id,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "event_id", $$v);
      },
      expression: "point.event_id"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "source type"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.point.source_type,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "source_type", $$v);
      },
      expression: "point.source_type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "source id"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.point.source_id,
      callback: function callback($$v) {
        _vm.$set(_vm.point, "source_id", $$v);
      },
      expression: "point.source_id"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(" 返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.isSubmitting
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" 儲存 ")]) : _vm._e()], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }